import { Component } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-alert-modal",
  templateUrl: "./alert-modal.component.html",
  styleUrls: ["./alert-modal.component.scss"],
})
export class LayoutAlertModalComponent {
  title: string;
  description: string;
  accept: string;
  reject: string;
  hasOkBtn: boolean = true;

  constructor(public modalRef: NgbModal) {}

  decline() {} // external override
  onDecline() {
    if (typeof this.decline === "function") {
      this.decline();
    }
    this.modalRef.dismissAll();
  }
}
